import { callGet, callPatch, callPost } from "../../services/axios";

export const createNotification = ({ type, domain, emailChainId, emailId, emailFrom, emailTo, bodyPreview, supplierId, phone, isRead, listSupplierId, qaRejectionNotes, subject, callerAssigned }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/notification/createNotification`, { type, domain, emailChainId, emailId, emailFrom, emailTo, bodyPreview, supplierId, phone, isRead, listSupplierId, qaRejectionNotes, subject, callerAssigned }, token).then(async (res) => {
        return Promise.resolve(res?.data)
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const getAllNotification = (limit, offset, type, callSid, filterValue = 'all') => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/notification/getNotification`, { offset, limit, type, callSid, filterValue }, token).then(async (res) => {
        return Promise.resolve(res?.data)
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const getContactByEmail = (emails) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/contact/getContactByEmail`, { emails }, token).then(async (res) => {
        return Promise.resolve(res?.data)
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const getEmailDetailsByEmailChainId = (emailChainIds) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/emailSettings/getEmailDetailsByEmailChainId`, { emailChainIds }, token).then(async (res) => {
        return Promise.resolve(res?.data)
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const getEmailDetailsByConversationId = (accessToken, email, conversationId, refreshToken, domain) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/emailSettings/getEmailDetailsByConversationId`, { accessToken, email, conversationId, refreshToken, domain }, token).then(async (res) => {
        return Promise.resolve(res?.data)
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const searchNotifications = (searchTerm, limit, offset, type) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/notification/searchNotifications`, { searchTerm, limit, offset, type }, token).then(async (res) => {
        return Promise.resolve(res?.data)
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const callConnectionAfterNotification = (connectionArray) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/notification/callConnectionAfterNotification`, { connectionArray }, token).then(async (res) => {
        return Promise.resolve(res?.data?.connected)
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const modifyNotification = (notificationIds, action, notificationType) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/notification/modifyNotification`, { notificationIds, action, notificationType }, token).then(async (res) => {
        return Promise.resolve(res?.data?.connected)
    }).catch(err => {
        return Promise.reject(err)
    })
}

export const getNotificationsUnified = ({ offset, limit, type, callSid, filterValue, searchTerm, unReadFilterApplied, filter, checkedFilter }) => (dispatch, getState) => {
    const { auth: { token } } = getState()
    return callPost(`/api/notification/getNotificationsUnified`, { offset, limit, type, callSid, filterValue, searchTerm, unReadFilterApplied, filter, checkedFilter }, token).then(async (res) => {
        return Promise.resolve(res?.data)
    }).catch(err => {
        return Promise.reject(err)
    })
}


